import { takeEvery, put, select } from 'redux-saga/effects';

import { API_CALL } from '../actionTypes/sharedActions';
import { UPDATE_RESTAURANT_SERVICE_STATUS } from '../routes';
import restaurantOrderActions from '../actionTypes/restaurantOrderActions';

const getRestaurantId = state => state.currentRestaurant.id;

function* updateRestaurantServiceStatus({ payload }) {
  const id = yield select(getRestaurantId);

  yield put({
    type: API_CALL,
    payload: {
      url: UPDATE_RESTAURANT_SERVICE_STATUS.replace(':id', id),
      method: 'PATCH',
      data: {
        accepting_orders: payload
      }
    },
    successAction: restaurantOrderActions.updateRestaurantServiceStausSuccess,
    failureAction: restaurantOrderActions.updateRestaurantServiceStausFailed
  });
}

export default function* watchRestaurantOrder() {
  yield takeEvery(
    restaurantOrderActions.updateRestaurantServiceStaus,
    updateRestaurantServiceStatus
  );
}
